import type { CompoundSelectSettingType } from '../../SelectCompound/types';
import type { SelectValueType } from '../../type';

import { SelectVariantType } from '../../SelectCompound/types';
import { PopoverActionList } from './PopoverActionList';
import { useEffect, useMemo, useState } from 'react';
import { SearchField } from '../../SearchFiled';
import { Popover, Box } from '@shopify/polaris';
import { PopoverChoice } from './PopoverChoice';
import { useSearch } from '../hooks';

export interface SelectPopoverProps extends CompoundSelectSettingType {
  activator: React.ReactElement;
  popoverActive: boolean;
  togglePopoverActive: (value: boolean) => void;
  isShowNoData?: boolean;
  header?: React.ReactNode;
  onChangeValue?: (id: string, value: SelectValueType) => void;
}

export const SelectPopover: React.FC<SelectPopoverProps> = ({
  width,
  header,
  tabs: _tabs,
  ...props
}) => {
  const { activator, popoverActive, togglePopoverActive, isShowSearch, enableCreateOption } = props;
  const [queryValue, setQueryValue] = useState('');

  const { options } = useSearch({
    options: props.options,
    queryValue,
    enableCreateOption,
  });

  const popoverContent = useMemo(() => {
    switch (props.variant) {
      case SelectVariantType.ACTION_LIST:
        return <PopoverActionList {...props} options={options} />;
      case SelectVariantType.CHOICE:
        return <PopoverChoice {...props} options={options} popoverActive={popoverActive} />;
    }
  }, [props, options, popoverActive]);

  useEffect(() => {
    if (!popoverActive) return;
    const popoverPane = document.querySelector('.Polaris-Popover__Pane.Polaris-Scrollable');
    if (popoverPane) {
      (popoverPane as HTMLElement).style.overflowY = 'hidden';
      (popoverPane as HTMLElement).style.overflowX = 'hidden';
    }
  }, [popoverActive]);

  return (
    <Popover
      active={popoverActive}
      activator={activator}
      onClose={() => togglePopoverActive(false)}
    >
      <Box width={width} position="relative">
        {header}
        {isShowSearch && (
          <Box padding="300" paddingBlockEnd="050" paddingBlockStart={header ? '0' : '300'}>
            <SearchField queryValue={queryValue} onSearch={setQueryValue} />
          </Box>
        )}
        {popoverContent}
      </Box>
    </Popover>
  );
};
